let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("6folH"), load("ffEVr"), load("eufZR"), load("Wowvf"), load("4vd0S")]).then(() => parcelRequire('7FipJ'));